<template>
  <div class="story-blocks">
    <template v-for="(block, index) in blocks" :key="blockKey(block, index)">
      <h2
        v-if="block.type === 'heading'"
        :id="block.id"
        class="story-blocks__heading"
      >
        {{ block.text }}
      </h2>
      <p
        v-else-if="block.type === 'paragraph' && block.html"
        class="story-blocks__paragraph"
        v-html="block.text"
      />
      <p v-else-if="block.type === 'paragraph'" class="story-blocks__paragraph">
        {{ block.text }}
      </p>
      <StoryQuote
        v-else-if="block.type === 'quote'"
        :quote="block.text"
        :author="block.author || defaultAuthor"
      />
    </template>
  </div>
</template>

<script>
import StoryQuote from './StoryQuote.vue';

export default {
  components: {
    StoryQuote,
  },
  props: {
    blocks: {
      type: Array,
      required: true,
    },
    defaultAuthor: {
      type: Object,
      required: true,
    },
  },
  methods: {
    blockKey(block, index) {
      if (block.id) return block.id;
      if (block.type === 'heading') return `heading-${block.text}`;
      return `${block.type}-${index}`;
    },
  },
};
</script>

<style scoped>
.story-blocks__heading {
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.02em;
  color: #17191d;
  margin: 48px 0 20px;
  scroll-margin-top: 24px;
}

.story-blocks__heading:first-child {
  margin-top: 0;
}

.story-blocks__paragraph {
  font-size: 18px;
  line-height: 28px;
  color: #17191d;
  margin-bottom: 20px;
}

.story-blocks__paragraph:last-child {
  margin-bottom: 0;
}

.story-blocks__paragraph :deep(a) {
  color: #7693fc;
  font-weight: 600;
}

.story-blocks__paragraph :deep(a:hover) {
  opacity: 0.8;
}

.story-blocks__paragraph :deep(strong) {
  font-weight: 600;
}
</style>
